import React, {Component} from "react"

class SvgText extends Component {
  render() {

    const height = this.props.height || 40
    const width = this.props.width || 300
    const fontSize = this.props.fontSize || 24

    const alignment = this.props.alignment || 'left'

    const defaultValuesByAlignment = {
      left: {
        x: 0,
        textAnchor: 'start'
      },
      center: {
        x: width/2,
        textAnchor: 'middle'
      },
      right: {
        x: width,
        textAnchor: 'end'
      },
    }

    const x = this.props.x || defaultValuesByAlignment[alignment].x
    const y = this.props.y || (height/2) + (fontSize/2)

    const weight = this.props.weight || 'default'
    const color = this.props.color || '#000000'
    const textAnchor = this.props.textAnchor || defaultValuesByAlignment[alignment].textAnchor

    return (
      <svg height={height} width={width}>
        <text fontSize={`${fontSize}px`} y={y} x={x}
              textAnchor={textAnchor}
              fontWeight={weight}
              fill={color} >
          {this.props.text}
        </text>
      </svg>
    )
  }
}

export default SvgText



// WEBPACK FOOTER //
// ./src/components/report/SvgText.js